<template>
    <v-container class="container">
        <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-system-bar height="70px" dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Trailer Form
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-system-bar>
                <v-tabs centered>
                    <v-tab>General Information</v-tab>
                    <v-tab>Compartment Information</v-tab>
                    <v-tab-item class="mx-5">
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="Trailer Name"
                                    v-model="editedItem.Trailer"
                                    required
                                    :rules="[v => !!v || 'Trailer is required']"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    label="VIN"
                                    v-model="editedItem.VIN"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="2">
                                <v-text-field
                                    label="Preloaded Order"
                                    v-model="editedItem.PreloadedOrder"
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Trailer capacity specs"
                                    v-model="editedItem.TrailerSpec"
                                    :rules="[
                                        v =>
                                            !!v ||
                                            'Trailer capacity specs is required'
                                    ]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Axle Quantity"
                                    v-model="editedItem.NumAxles"
                                    :rules="[
                                        v => !!v || 'Axle Quantity is required'
                                    ]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row
                            justify="center"
                            style="display: flex; align-items: center;"
                        >
                            <v-col cols="2" style="max-width: 10%;">
                                <v-switch
                                    label="Out Service"
                                    v-model="editedItem.OutService"
                                    input-value="true"
                                ></v-switch>
                            </v-col>
                            <v-col cols="3" style="max-width: 20%;">
                                <v-autocomplete
                                    v-model="editedItem.RegionId"
                                    :items="regions"
                                    item-text="PrincipalRegion"
                                    item-value="PrincipalRegionID"
                                    dense
                                    label="Region"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="3" style="max-width: 20%;">
                                <v-combobox
                                    v-model="product"
                                    :items="spcProducts"
                                    label="Specific Product"
                                    :item-text="'GroupName'"
                                    :item-value="'SpProductGrpID'"
                                    @change="selectProduct"
                                    auto-select-first
                                    dense
                                ></v-combobox>
                            </v-col>
                            <v-col cols="2" style="max-width: 10%;">
                                <v-text-field
                                    label="GeotabID"
                                    v-model="editedItem.TrailerGeotabID"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item class="mx-5">
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="Compartment 1 Vol"
                                    v-model="editedItem.Comp1"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    label="Compartment 2 Vol"
                                    v-model="editedItem.Comp2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="Compartment 3 Vol"
                                    v-model="editedItem.Comp3"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    label="Compartment 4 Vol"
                                    v-model="editedItem.Comp4"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="Compartment 5 Vol"
                                    v-model="editedItem.Comp5"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    label="Compartment 6 Vol"
                                    v-model="editedItem.Comp6"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs>

                <v-container>
                    <v-row justify="end">
                        <v-btn
                            dark
                            color="secondary"
                            class="mx-5 white--text"
                            @click="validate()"
                        >
                            Save
                            <v-icon right dark>mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn
                            exact
                            dark
                            color="secondary"
                            class="mr-5 white--text"
                            :to="'/catalogs/trailers'"
                        >
                            Close
                            <v-icon right dark>mdi-close</v-icon>
                        </v-btn>
                    </v-row>
                </v-container>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: 'TrailersForm',
    data() {
        return {
            valid: true,
            trailerID: 0,
            products: [],
            product: [],
            defaultItem: {
                Trailer: null,
                TrailerSpec: null,
                PreloadedOrder: null,
                NumAxles: null,
                Comp1: null,
                Comp2: null,
                Comp3: null,
                Comp4: null,
                Comp5: null,
                Comp6: null,
                VIN: null,
                TrailerGeotabID: '',
                RegionId: null
            },
            spcProducts: null,
            editedItem: {
                SpecificProductOnly: null,
                Active: null,
                Trailer: null,
                TrailerSpec: null,
                PreloadedOrder: null,
                NumAxles: null,
                Comp1: null,
                Comp2: null,
                Comp3: null,
                Comp4: null,
                Comp5: null,
                Comp6: null,
                VIN: null,
                TrailerGeotabID: '',
                RegionId: null
            }
        };
    },
    mounted() {
        this.loadTrailerData();
        this.loadRegions();
    },
    methods: {
        loadProducts: function() {
            this.$store.state.isLoading = true;
            axios
                .get('product/active')
                .then(response => {
                    this.products = response.data.data;
                    const index = this.products.findIndex(elm => {
                        return (
                            elm.ProductID == this.editedItem.SpecificProductOnly
                        );
                    });
                    console.log(index);
                    this.product = this.products[index];

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        selectProduct: function() {
            this.editedItem.SpecificProductOnly = this.product.SpProductGrpID;
        },
        loadTrailerData: function() {
            this.trailerID = this.$store.state.editedTrailer.id;
            this.$store.state.isLoading = true;
            var str = this.$store;
            if (this.trailerID != 0) {
                axios
                    .get('trailer/' + this.trailerID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.loadSpecialProductGroup();
                        this.editedItem = Object.assign({}, response.data);
                        // this.$store.state.editedTrailer.id = 0;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            } else {
                this.loadSpecialProductGroup();
            }
            this.$store.state.isLoading = false;
        },
        newTrailer: function() {
            console.log(this.editedItem);
            this.$store.state.isLoading = true;
            this.editedItem.Active = true;
            var str = this.$store;
            axios
                .post('trailer', this.editedItem)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New trailer added.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/trailers');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        editTrailer: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            console.log(this.editedItem);
            if (this.product == null) {
                this.editedItem.SpecificProductOnly = null;
            }
            axios
                .put('trailer/' + this.trailerID, this.editedItem)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Trailer information saved.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/trailers');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        loadSpecialProductGroup: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('special-product-group', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.spcProducts = response.data;
                    const index = this.spcProducts.findIndex(elm => {
                        return (
                            elm.SpProductGrpID ==
                            this.editedItem.SpecificProductOnly
                        );
                    });
                    console.log(index);
                    this.product = this.spcProducts[index];
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        save: function() {
            console.log(this.trailerID);
            if (this.trailerID >= 1) {
                this.editTrailer();
            } else {
                this.newTrailer();
            }
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.save();
            }
        },
        loadRegions() {
            axios
                .get('trailer/regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                    console.log('Regions: ', this.regions);
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
